import routeHelper from "helpers/route"

export default routeHelper.lazyLoadRoute(() => import("containers/PageXbox"), "containers/PageXbox")
